import { useEffect, useState } from "react";
import axios from "axios";
import styles from "../assets/css/Promotions.module.css";
import { BASE_URL } from "../constants/constants";
import Header from "../components/Header";
import List from "../components/List";
import SelectTypeModal from "../components/SelectTypeModal";
import AddPromotion from "../addComponents/addPromotion";
import AddPromotionSecondType from "../addComponents/addPromotion2";
import AddPromotionThirdType from "../addComponents/addPromotion3";
import AddPromotionFourthType from "../addComponents/addPromotion4";
import DeletePromotion from "../deleteComponents/DeletePromotion";

const Promotions = () => {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");
  const [activeModal, setActiveModal] = useState(null);
  const [deletePromotion, setDeletePromotion] = useState(null);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    fetchPromotions();
  }, []);

    const fetchPromotions = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/v0/promotions`, {
          headers,
        });
        setPromotions(response.data.result || []);
      } catch (err) {
        setError("Ошибка загрузки акций");
      } finally {
        setLoading(false);
      }
    };

  const closeModal = () => setActiveModal(null);

  const handlePromotionDelete = (id) => {
    axios.delete(`${BASE_URL}/v0/promotions/` + id, { headers }).then(() => {
      fetchPromotions();
      setDeletePromotion(null);
    });
  };

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString("ru-RU") : "";
  };

  if (loading) return <div className={styles.loading}>Загрузка...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.block}>
            <div className={styles.label}>Акции</div>
            <button onClick={() => setActiveModal("selectType")} className={styles.createbutton}>
              <div className={styles.text1}>Создать</div>
              <img
                className={styles.createicon}
                src="/images/add.svg"
                alt="add icon"
              />
            </button>
          </div>
          <div className={styles.wrapper}>
            <div className={styles.dataWrapper}>
              {promotions.map((promo) => (
                <div key={promo.id} className={styles.promoItem}>
                  <img
                    className={styles.image}
                    src={
                      promo.imageSrc
                        ? `${BASE_URL}/v0/${promo.imageSrc}`
                        : "/images/promotion.svg"
                    }
                    alt={promo.title}
                  />
                  <div className={styles.title}>{promo.title}</div>
                  <div className={styles.description}>
                    {promo.bannerDescription || "Описание отсутствует"}
                  </div>
                  <div className={styles.date}>
                    {promo.startDate
                      ? ` С ${formatDate(promo.startDate)}`
                      : "Дата отсуствует"}
                    <br />
                    {promo.deadline
                      ? `До ${formatDate(promo.deadline)}`
                      : "Дата отсутствует"}
                  </div>
                  <div className={styles.box}>
                    {/* <img
                      // onClick={() => openEditModal(el.id)}
                      className={styles.icons}
                      src="/images/edit.svg"
                      alt="edit icon"
                    /> */}
                    <img
                      onClick={() => setDeletePromotion(promo.id)}
                      className={styles.icons}
                      src="/images/delete.svg"
                      alt="delete icon"
                    />
                    {deletePromotion === promo.id && (
                      <DeletePromotion
                        onClose={() => handlePromotionDelete(promo.id)}
                        category={promo}
                        onCloseModal={() => setDeletePromotion(null)}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {activeModal === "selectType" && (
          <SelectTypeModal
            onClose={closeModal}
            onSelect={(type) => setActiveModal(type)}
          />
        )}
        {activeModal === "type1" && <AddPromotion onClose={closeModal} onUpdate={fetchPromotions} />}
        {activeModal === "type2" && (
          <AddPromotionSecondType onClose={closeModal} onUpdate={fetchPromotions} />
        )}
        {activeModal === "type3" && (
          <AddPromotionThirdType onClose={closeModal} onUpdate={fetchPromotions} />
        )}
        {activeModal === "type4" && (
          <AddPromotionFourthType onClose={closeModal} onUpdate={fetchPromotions} />
        )}
      </div>
    </div>
  );
};

export default Promotions;
